import { BannerStrapiProps } from '@/components/atoms/banner/BannerStrapi';
import { normalizeBannerProps } from '@/components/atoms/banner/utils';
import { passButtonIcons } from '@/components/atoms/Button/utils';
import Card from '@/components/atoms/Card';
import ImageStrapi from '@/components/atoms/Image/ImageStrapi';
import LinkButtonStrapi, {
  LinkButtonStrapiProps,
} from '@/components/atoms/LinkButton/LinkStrapi';
import RichTextFieldStrapi from '@/components/atoms/RichTextField/RichTextFieldStrapi';
import { Text } from '@/components/atoms/Text';

type Props = {
  banner: BannerStrapiProps;
};

/**
 * Reduced version of the banner where less emphasis is required.
 */
const FollowUpBanner = ({ banner }: Props) => {
  const { image, title, description, buttons } = normalizeBannerProps(
    banner as BannerStrapiProps
  );

  return (
    <Card
      classNames={{
        root: 'flex w-full p-6 justify-between flex-col lg:flex-row gap-8 lg:gap-4',
      }}
      color='gradient'
    >
      <div
        className="text-left flex flex-col md:flex-row gap-y-5 md:gap-x-6 items-start flex-1 pb-2 md:pb-0"
      >
        {!!image && (
          <ImageStrapi
            block={image}
            inner={{
              classNames: {
                image: 'w-9 h-9',
              },
            }}
          />
        )}
        <div className='flex flex-col gap-y-2'>
          {!!title && (
            <Text
              variant='subtitle-l-d'
              color='gray-900'
              classNames={{ wrapper: 'font-serif' }}
            >
              {title}
            </Text>
          )}

          {!!description && (
            <Text as='div' color='gray-500' variant='body-l'>
              <RichTextFieldStrapi block={description} />
            </Text>
          )}
        </div>
      </div>
      <div className='flex md:flex-row flex-col items-center gap-4'>
        {buttons?.map((button, index) => (
          <LinkButtonStrapi
            key={index}
            block={button as LinkButtonStrapiProps}
            inner={{
              size: 'm',
              ...button,
              classNames: {
                root: 'w-full md:w-auto ',
              },
              ...passButtonIcons({
                ...button,
              }),
            }}
          />
        ))}
      </div>
    </Card>
  );
};

export default FollowUpBanner;
